import React from "react"
import { Button } from "reactstrap"
import MentionDropdown from "../ui/MentionDropdown"
import { User, DisplayMessage } from "../../ZeefTypes"

interface ZeefMessageInputProps {
  inputMessage: string
  isConnected: boolean
  isLoading: boolean
  isLoadingUser: boolean
  isBroadcastMode: boolean
  replyingToMessage: DisplayMessage | null
  showMentionDropdown: boolean
  mentionSuggestions: User[]
  messageInputRef: React.RefObject<HTMLInputElement>
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onInputKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onSendMessage: (event: React.FormEvent) => void
  onCancelReply: () => void
  onToggleBroadcastMode: () => void
  onMentionSelect: (user: User) => void
}

const ZeefMessageInput: React.FC<ZeefMessageInputProps> = ({
  inputMessage,
  isConnected,
  isLoading,
  isLoadingUser,
  isBroadcastMode,
  replyingToMessage,
  showMentionDropdown,
  mentionSuggestions,
  messageInputRef,
  onInputChange,
  onInputKeyDown,
  onSendMessage,
  onCancelReply,
  onToggleBroadcastMode,
  onMentionSelect,
}) => {
  return (
    <form onSubmit={onSendMessage} className="message-input-form">
      {replyingToMessage && (
        <div className="reply-indicator">
          <div className="reply-info">
            <span className="reply-label">Replying to:</span>
            <span className="reply-username">{replyingToMessage.sender?.username || "Unknown"}</span>
            <span className="reply-content">
              {replyingToMessage.content?.substring(0, 50)}
              {replyingToMessage.content?.length > 50 ? "..." : ""}
            </span>
          </div>
          <button
            type="button"
            className="cancel-reply-btn"
            onClick={onCancelReply}
            title="Cancel reply"
          >
            ✕
          </button>
        </div>
      )}
      
      <div className="message-mode-toggle">
        <button
          type="button"
          className={`mode-toggle-btn ${isBroadcastMode ? "broadcast-mode" : "regular-mode"}`}
          onClick={onToggleBroadcastMode}
          disabled={!isConnected || isLoading || isLoadingUser}
          title={isBroadcastMode ? "Broadcasting to all followers" : "Sending to mutual follows"}
        >
          {isBroadcastMode ? "BROADCAST" : "REGULAR"}
        </button>
      </div>
      
      <div className="input-container">
        <div className="input-wrapper">
          <input
            ref={messageInputRef}
            type="text"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="sentences"
            spellCheck="true"
            data-lpignore="true"
            data-form-type="other"
            placeholder={
              isConnected
                ? isBroadcastMode
                  ? "Broadcast message... (use @username to mention)"
                  : "Type your message... (use @username to mention)"
                : "Connecting..."
            }
            value={inputMessage}
            onChange={onInputChange}
            onKeyDown={onInputKeyDown}
            disabled={!isConnected || isLoading || isLoadingUser}
            className={`form-control zeef-input ${isBroadcastMode ? "broadcast-input" : ""}`}
          />
          {showMentionDropdown && mentionSuggestions.length > 0 && (
            <MentionDropdown suggestions={mentionSuggestions} onSelect={onMentionSelect} />
          )}
        </div>
        {inputMessage.trim() && (
          <Button type="submit" className="send-btn" disabled={!isConnected || isLoading || isLoadingUser}>
            {isLoading ? "..." : "→"}
          </Button>
        )}
      </div>
    </form>
  )
}

export default ZeefMessageInput
